<template>
  <v-container grid-list-lg>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="elevation-0 transparent">
          <v-card-title>Výrobný príkaz id: {{$route.params.id}}</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="8" md="6" lg="3">
                <ValidationProvider v-slot="{ errors }" name="E-mail" rules="email|required">
                  <v-text-field
                    v-model="manufacturingCommand.name"
                    label="Názov"
                    hint="odporúčaný typ názvu: VP-DURIS"
                    :error-messages="errors"
                    @keyup="save()"
                    required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="8" md="6" lg="3">
                <ValidationProvider v-slot="{ errors }" name="E-mail" rules="email|required">
                  <v-text-field
                    v-model="manufacturingCommand.description"
                    @keyup="save()"
                    :error-messages="errors"
                    label="Popis"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <OrderDetailsTable
          ref="orderDetailsDialog"
          @selected-items="addDetailItems"
          :loadDefaulValues="true"
        />
      </v-col>
      {{manufacturingCommand.ManufacturingDetails}}
    </v-row>
  </v-container>
</template>

<script>
// import { debounce } from "lodash-es";
import UnitOfWorkService from "@/services/UnitOfWorkService";
import {
  commandUpdateTableHeader,
  orderDetailsTableHeader
} from "@/views/manufacturing_command/js/tableHeaders";
// import CommandDetailListItem from "@/views/manufacturing_command/components/CommandDetailListItem";
import OrderDetailsTable from "@/views/manufacturing_command/components/OrderDetailsTable";

export default {
  name: "CommandUpdate",
  components: { OrderDetailsTable },
  data() {
    return {
      commandUpdateTableHeader: commandUpdateTableHeader,
      orderDetailsTableHeader: orderDetailsTableHeader,
      unprocessedOrderDetails: [],
      manufacturingCommand: {},
      commandDetails: null,
      itemsPerPageOptions: [6, 8, 10, 12],
      itemsPerPage: 6,
      selectedItems: [],
      dialog: false
    };
  },

  methods: {
    addDetailItems(items) {
      this.manufacturingCommand.ManufacturingDetails = items;
    },

    submit() {
      this.openGlobalLoader("Ukladá sa ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .postManufacturingCommand(this.manufacturingCommand)
        .then(response => {
          console.log(response);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    }
  }
};
</script>
